import { Component, HostListener, effect, Injector, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ApiService } from 'src/app/services/api.service';
import { localStorageService } from 'src/app/services/localstorage.service';
import { MainService } from 'src/app/services/main.service';
import { SharedService } from 'src/app/services/shared.service';
import { EConsentModalComponent } from 'src/app/shared/e-consent-modal/e-consent-modal.component';
// import { localStorageService } from '../../../../services/localstorage.service';
// import { SharedService } from '../../../../services/shared.service';
// import { LogoutModalComponent } from 'src/app/shared/logout-modal/logout-modal.component';

@Component({
  selector: 'app-layout-header',
  templateUrl: './layout-header.component.html',
  styleUrl: './layout-header.component.scss'
})
export class LayoutHeaderComponent {
allSettingsList = [
  {
    label: 'Profile',
    icon: 'assets/images/icons/user-icon.svg',
    path: 'app/profile'
  },
  {
    label: 'Manage Users',
    icon: 'assets/images/icons/ManageUser.svg',
    path: 'app/manage-users'
  },
  {
    label: 'Help & Support',
    icon: 'assets/images/icons/support-icon.svg',
    path: 'app/support'
  }
];
  userProfile: any;
  bsModalRef: BsModalRef | undefined;
  showLogout = false;
  search_string = '';
  settingsList: any[] = [];
  business_brand_outreach:any;
  // quickbooksIntegrated = false;

  constructor(private _local: localStorageService, private _router: Router, private _api: ApiService, public _shared: SharedService, public modalService: BsModalService, private mainService: MainService, private injector: Injector, private cdr: ChangeDetectorRef) {
    this.userProfile = this._local.customGetItem('userProfileData');
    this.business_brand_outreach = this.userProfile.business_brand_outreach;
    effect(() => {
      const res = this.mainService.consentData();
      if (res && res.business_brand_outreach) {
        this.business_brand_outreach = res.business_brand_outreach;
        if (this.business_brand_outreach == 2) {
          this.modalService.hide();
        }
      }
    });
  }

  ngOnInit(): void {
    // check if quickbooks connected
    // if (window.location.href.includes('code')) {
    //   this._api.api({param: window.location.href},'quickbooks/callback').subscribe(resp => {
    //     if (resp.flag === 200) {
    //       this.quickbooksIntegrated = true;
    //       // window.close();
    //     }
    //   })
    // }

  effect(() => {
  const response = this._shared.doctorProfile();
  this.userProfile = response;

  if (response && response.business_brand_outreach) {
    this.business_brand_outreach = response.business_brand_outreach;
  }

  // placeholder image fix
  if (
    this.userProfile &&
    this.userProfile.doctor_image &&
    this.userProfile.doctor_image.includes('profile_placeholder')
  ) {
    this.userProfile['doctor_image'] = 'assets/images/icons/profile_placeholder.png';
  }

  // ROLE BASED NORMALIZATION
  if (this.userProfile?.role_id === 5) {
    // agent → map to doctor fields for UI reuse
    this.userProfile.doctor_name = this.userProfile.agent_name;
    this.userProfile.doctor_email = this.userProfile.agent_email;
    this.userProfile.doctor_image = this.userProfile.agent_image;
  }

  // existing logic stays same
  if (this.userProfile?.role_id === 5) {
    this.settingsList = this.allSettingsList.filter(
      item => item.label === 'Profile' || item.label === 'Help & Support'
    );
  } else {
    this.settingsList = this.allSettingsList;
  }
}, { injector: this.injector, allowSignalWrites: true });


  }

  openNavMenu() {
    const sidenav = document.getElementById('mySidenav');
    if (sidenav) {
      sidenav.style.transform = 'translate(0%)';
    }
  }

  showLogoutModal() {
    this.showLogout = true;
  }

  @HostListener('document:click', ['$event.target'])
  onClick(event: EventTarget | null): void {
    if (!(event instanceof Element)) {
      return;
    }

    if (!event.classList.contains('lhc') && !event.classList.contains('logout-wrapper') && !event.classList.contains('profile-icon')) {
      this.showLogout = false;
    }
  }

  userAction(action: any) {
    this._router.navigate([action.path]);
  }

  emitSeacrh() {
    this._shared.search_emitter.next(this.search_string);
  }

  connect() {
    this._api.api({},'quickbooks/authUri').subscribe(resp => {
      console.log(resp);
      if (resp && resp.data) {
        window.open(resp.data, '_self')
      }
    })
  }

  getCustomersList() {
    this._api.api({},'quickbooks/getCustomer', 'get').subscribe(resp => {
      console.log(resp);
    })
  }

  openPenidngOutreach() {
    const storedEndTime = localStorage.getItem('outreach_timer_end');

    if (storedEndTime) {
      const endTime = Number(storedEndTime);
      const remainingSeconds = Math.floor((endTime - Date.now()) / 1000);

      if (remainingSeconds > 0) {

        this.bsModalRef = this.modalService.show(EConsentModalComponent, {
          initialState: {
            modalType: this._shared.modalTypes.awaitingApproval
          },
          class: 'modal-dialog-centered',
          backdrop: 'static',
          keyboard: false
        });
      } else {
        // ❌ User came back to the route, but the timer finished while they were gone.
        this.bsModalRef = this.modalService.show(EConsentModalComponent, {
          initialState: {
            modalType: this._shared.modalTypes.pendingApproval
          },
          class: 'modal-dialog-centered',
          backdrop: 'static',
          keyboard: false
        });
      }
    } else {
      // ⚪ No active timer exists (First visit, or previously expired)
      this.bsModalRef = this.modalService.show(EConsentModalComponent, {
        initialState: {
          modalType: this._shared.modalTypes.pendingApproval
        },
        class: 'modal-dialog-centered',
        backdrop: 'static',
        keyboard: false
      });
    }

  }
}
